module.exports = __webpack_public_path__ + "static/media/D2_C5_001.c29db6b7.png";